export const passwordLabel = {
  0: 'Veldig svakt',
  1: 'Svakt',
  2: 'OK',
  3: 'Bra',
  4: 'Sterkt',
};
export const barColor = {
  0: 'var(--danger-color)',
  1: 'var(--color-orange-6)',
  2: 'var(--color-yellow-5)',
  3: 'var(--color-green-6)',
  4: 'var(--color-green-7)',
};
export const passwordFeedbackMessages: Record<string, string> = {
  'Add another word or two. Uncommon words are better.':
    'Legg til et ord eller to. Uvanlige ord er best.',
  'Straight rows of keys are easy to guess':
    'Rader fra tastaturet er enkle å gjette.',
  'Short keyboard patterns are easy to guess':
    'Korte keyboardmønstre er enkle å gjette',
  'Use a longer keyboard pattern with more turns':
    'Bruk et lengre keyboardmønster med større variasjon.',
  'Repeats like "aaa" are easy to guess':
    'Gjentakelser som "aaa" er enkle å gjette.',
  'Repeats like "abcabcabc" are only slightly harder to guess than "abc"':
    'Gjentakelser som "abcabcabc" er kun litt vanskeligere å gjette enn "abc".',
  'Avoid repeated words and characters': 'Unngå gjentakende ord og tegn.',
  'Sequences like abc or 6543 are easy to guess':
    'Sekvenser som "abc" eller "6543" er enkle å gjette.',
  'Recent years are easy to guess': 'Nylige år er enkle å gjette.',
  'Avoid years that are associated with you':
    'Unngå år som kan assosieres med deg.',
  'Dates are often easy to guess': 'Datoer er ofte enkle å gjette.',
  'Avoid dates and years that are associated with you':
    'Unngå datoer og år som kan assosieres med deg.',
  'This is a top-10 common password':
    'Dette er et av de topp 10 vanligste passordene.',
  'This is a top-100 common password':
    'Dette er et av de topp 100 vanligste passordene.',
  'This is a very common password': 'Dette er et veldig vanlig passord.',
  'This is similar to a commonly used password':
    'Dette likner på et veldig vanlig passord.',
  'A word by itself is easy to guess': 'Ett enkelt ord er enkelt å gjette.',
  'Names and surnames by themselves are easy to guess':
    'Fornavn og etternavn er enkle å gjette.',
  'Common names and surnames are easy to guess':
    'Vanlige navn er enkle å gjette.',
  "Capitalization doesn't help very much":
    'Stor forbokstav gir ikke mye vanskeligere passord.',
  'All-uppercase is almost as easy to guess as all-lowercase':
    'Kun store bokstaver er nesten like lette å gjette som kun små bokstaver.',
  "Reversed words aren't much harder to guess":
    'Reverserte ord er nesten like enkle å gjette som originalordet.',
  "Predictable substitutions like '@' instead of 'a' don't help very much":
    "Forutsigbare erstatninger som '@' istedenfor 'a' gir ingen stor forbedring.",
};
